<template>
  <BaseButton type="button" primary @click="showCreateRoleDialog">Add role</BaseButton>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    showCreateRoleDialog() {
      this.$modal.show({
        component: () => import('./CreateRoleDialog.vue'),
        props: {
          accountId: this.accountId,
        },
        on: {
          created: () => {
            this.$emit('created');
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
